import AOS from "aos";
import lozad from "lozad";
import {
  setBackgroundElement,
  detectCloseElement,
  buttonToTop,
  clickScrollToDiv,
  appendCaptchaASP,
} from "./helper";
import { header } from "./header";
import swiperInit from "./swiper";
$(document).ready(function () {
  setBackgroundElement();
  header.init();
  swiperInit();
  FAQ();
  appendCaptchaASP();
  replaceSvgImages();
  clickSvg();
  buttonToTop();
});
function clickSvg() {
  $("body").on("click", ".ele-hover", function (e) {
    e.stopPropagation();
    const href = $(this).data("href");
    window.open(href, "_self");
  });
}

export function replaceSvgImages() {
  $(".img-svg").each(function () {
    const $img = $(this);
    const imgURL = $img.attr("src");
    const imgClass = $img.attr("class");
    const imgWidth = $img.attr("width");
    const imgHeight = $img.attr("height");

    $.ajax({
      url: imgURL,
      dataType: "text",
      success: function (svgContent) {
        // Create a new div to hold the SVG content
        const $svgDiv = $("<div>").html(svgContent);
        const $svg = $svgDiv.find("svg");

        // Apply original image attributes to SVG
        if (imgClass) {
          $svg.addClass(imgClass);
        }

        // Replace the image with the SVG
        $img.replaceWith($svg);
      },
      error: function (error) {
        console.error("Error fetching SVG:", error);
      },
    });
  });
}

/*==================== Aos Init ====================*/
AOS.init({
  offset: 100,
});

/*==================== FAQ =================*/
function FAQ() {
  $(".faq-full-content .main-faq:nth-child(1)").addClass("active-faq");
  $(".faq-full-content .main-faq:nth-child(1) .heading-faq").addClass("active");
  $(".faq-full-content .main-faq:nth-child(1) .content-faq").slideDown();
  $(".heading-faq").on("click", function () {
    var $mainFaq = $(this).closest(".main-faq");
    if ($(this).hasClass("active")) {
      $(this).siblings(".content-faq").slideUp();
      $(this).removeClass("active");
      $mainFaq.removeClass("active-faq");
    } else {
      $(".heading-faq").removeClass("active");
      $(".content-faq").slideUp();
      $(".main-faq").removeClass("active-faq");

      $(this).siblings(".content-faq").slideToggle();
      $(this).toggleClass("active");
      $mainFaq.addClass("active-faq");
    }
  });
}
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
window.observer = observer;
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("myModal");
  const openModalButton = document.getElementById("MainNavMain");
  const closeModalButtons = document.querySelectorAll(".close, .btn-default");

  openModalButton.addEventListener("click", function () {
    modal.classList.add("show");
  });

  closeModalButtons.forEach((button) => {
    button.addEventListener("click", function () {
      modal.classList.remove("show");
    });
  });

  window.addEventListener("click", function (event) {
    if (event.target === modal) {
      modal.classList.remove("show");
    }
  });
});
